/*
 * Copyright (c) Nexign, JSC, 2019.
 */

/**
 *
 *
 * @author Yakov Gushchin
 * @version 1.0.0
 * @since 1.0.1
 */
import { memo } from 'react';

import { ESkeletonKind } from './skeletonTypes';
import { SkeletonChartCenterStyled, SkeletonChartStyled } from './styled/SkeletonChartStyled';

export interface ISkeletonChartProps {
    kind: ESkeletonKind;
    multiple: number;
}

const SkeletonChart = (props: ISkeletonChartProps) => (
    <SkeletonChartStyled kind={props.kind}>
        <SkeletonChartCenterStyled kind={props.kind} multiple={props.multiple} />
    </SkeletonChartStyled>
);

export default memo(SkeletonChart);
